import React, { useState, useEffect, useRef } from 'react';

const GameArea = ({ carPosition, carVisualPosition, gameState, onTap, progress, visibleProgress, roadScrollPosition }) => {
  // Game constants
  const [tapFeedback, setTapFeedback] = useState({ show: false, x: 0, y: 0 });
  const [hasFirstTap, setHasFirstTap] = useState(false);
  const tapAreaRef = useRef(null);

  // Handle tap events
  const handleTap = (event) => {
    if (gameState !== 'playing') return;
    
    event.preventDefault();
    
    // Set first tap flag
    if (!hasFirstTap) {
      setHasFirstTap(true);
    }
    
    // Show tap feedback
    const rect = tapAreaRef.current.getBoundingClientRect();
    let x, y;
    
    if (event.touches && event.touches[0]) {
      // Touch event
      x = event.touches[0].clientX - rect.left;
      y = event.touches[0].clientY - rect.top;
    } else {
      // Click event
      x = event.clientX - rect.left;
      y = event.clientY - rect.top;
    }
    
    setTapFeedback({ show: true, x, y });
    
    // Hide feedback after animation
    setTimeout(() => {
      setTapFeedback({ show: false, x: 0, y: 0 });
    }, 300);
    
    // Call parent tap handler
    onTap(event);
  };

  // Prevent context menu on long press
  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  // Prevent pull-to-refresh on mobile
  const handleTouchMove = (e) => {
    if (e.target.closest('.game-area')) {
      e.preventDefault();
    }
  };

  // Add haptic feedback for mobile devices
  useEffect(() => {
    if ('vibrate' in navigator && gameState === 'playing') {
      const handleVibrate = () => navigator.vibrate(50);
      
      const tapArea = tapAreaRef.current;
      if (tapArea) {
        tapArea.addEventListener('touchstart', handleVibrate);
        return () => tapArea.removeEventListener('touchstart', handleVibrate);
      }
    }
  }, [gameState]);

  // Reset first tap flag when game state changes to idle (game reset)
  useEffect(() => {
    if (gameState === 'idle') {
      setHasFirstTap(false);
    }
  }, [gameState]);

  return (
    <div className="game-area">
      {/* Progress Bar - Only show after first tap */}
      {hasFirstTap && (
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${visibleProgress}%` }}
            ></div>
          </div>
          <div className="progress-text">{Math.round(progress)}% Complete</div>
        </div>
      )}

                           {/* Road */}
        <div 
          className="road" 
          style={{ 
            transform: `translateX(-${roadScrollPosition}%)`,
            width: '200%'
          }}
        >
          {Array.from({ length: 1200 }, (_, index) => (
            <div key={index} className="road-lines"></div>
          ))}
        </div>

             {/* Car */}
       <div 
         className="car" 
         style={{ 
           left: `${carVisualPosition}%`,
           animation: gameState === 'won' ? 'bounce 0.5s infinite' : 'none'
         }}
       >
        <div className="car-body">
          <div className="car-top"></div>
          <div className="car-bottom"></div>
          <div className="car-wheel front-wheel"></div>
          <div className="car-wheel back-wheel"></div>
          <div className="car-lights"></div>
        </div>
      </div>

                           {/* Client (Finish Line) - Always at the end of the road */}
        <div 
          className="client" 
          style={{ 
            left: `${100 - roadScrollPosition}%`
          }}
        >
         <div className="client-icon">👔</div>
         <div className="finish-line"></div>
       </div>

      {/* Tap Area */}
      <div 
        ref={tapAreaRef}
        className="tap-area" 
        onClick={handleTap}
        onTouchStart={handleTap}
        onContextMenu={handleContextMenu}
        onTouchMove={handleTouchMove}
        style={{ cursor: gameState === 'playing' ? 'pointer' : 'default' }}
      >
        <div 
          className="tap-instruction"
          style={{
            animation: gameState === 'playing' ? 'pulse 0.5s infinite' : 'pulse 2s infinite',
            background: gameState === 'won' ? 'rgba(76, 175, 80, 0.8)' : 'rgba(0,0,0,0.7)',
            display: hasFirstTap && gameState !== 'won' ? 'none' : 'block'
          }}
        >
          {gameState === 'won' ? '🎉 YOU WIN! 🎉' : 'TAP HERE TO PUSH THE CAR!'}
        </div>
        
        {/* Tap Feedback */}
        {tapFeedback.show && (
          <div 
            className="tap-feedback"
            style={{
              left: tapFeedback.x,
              top: tapFeedback.y,
              opacity: 1,
              transform: 'scale(1.5)'
            }}
          >
            💨
          </div>
        )}
      </div>
    </div>
  );
};

export default GameArea;
